  export const DefaultMetaData = {
    title: 'Global Freight Forwarder Network & NVOCCs Platform | DF Alliance',
    description: 'DF Alliance is the trusted network for freight forwarders and NVOCCs. Join our global network to grow your logistics business through strategic partnerships.',
  };
  
  // Blacklist of pages where membership banner in modal window should not appear on:
  export const blacklistForMembershipBanner: Array<string> = [
    '/membership',
    '/auth/sign-up',
    '/auth/sign-in',
    '/auth/forgot-password',
    '/auth/confirm-password',
    '/partners/erp-enquiry',
  ];